module.exports = __webpack_public_path__ + "static/media/food.baf6c6bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/food.png
// module id = 186
// module chunks = 0